<div class="provider-section-grid" [formGroup]="formGroup">
  <div class="provider-section-header">
    <h5 class="section-title">
      {{ providerType === 'Tutor' ? 'Basic Information' : 'Personal Information' }}
    </h5>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="firstName" class="field-label">First Name</label>
      <mat-form-field class="provider-fields">
        <input
          id="firstName"
          matInput
          type="text"
          placeholder="First Name"
          class="user-record-field-input"
          formControlName="firstName" />
        @if (formGroup.get('firstName')?.invalid && formGroup.get('firstName')?.touched) {
          @if (formGroup.get('firstName')?.hasError('required')) {
            <mat-error>First Name is required</mat-error>
          } @else if (formGroup.get('firstName')?.hasError('name')) {
            <mat-error>{{ formGroup.get('firstName')?.getError('name')?.message ?? 'First Name format is invalid' }}</mat-error>
          } @else {
            <mat-error>First Name is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="lastName" class="field-label">Last Name</label>
      <mat-form-field class="provider-fields">
        <input
          id="lastName"
          matInput
          type="text"
          placeholder="Last Name"
          class="user-record-field-input"
          formControlName="lastName" />
        @if (formGroup.get('lastName')?.invalid && formGroup.get('lastName')?.touched) {
          @if (formGroup.get('lastName')?.hasError('required')) {
            <mat-error>Last Name is required</mat-error>
          } @else if (formGroup.get('lastName')?.hasError('name')) {
            <mat-error>{{ formGroup.get('lastName')?.getError('name')?.message ?? 'Last Name format is invalid' }}</mat-error>
          } @else {
            <mat-error>Last Name is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="email" class="field-label">Email Address</label>
      <mat-form-field class="provider-fields">
        <input
          id="email"
          matInput
          disabled
          type="text"
          placeholder="test@example.com"
          class="user-record-field-input"
          [value]="providerData.email" />
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="phone" class="field-label">Phone Number</label>
      <mat-form-field class="provider-fields">
        <input
          id="phone"
          matInput
          type="text"
          [mask]="'(000) 000-0000'"
          formControlName="phone"
          class="user-record-field-input"
          [dropSpecialCharacters]="false" />
        @if (formGroup.get('phone')?.invalid && formGroup.get('phone')?.touched) {
          @if (formGroup.get('phone')?.hasError('required')) {
            <mat-error>Phone number is required</mat-error>
          } @else if (formGroup.get('phone')?.hasError('invalidPhone')) {
            <mat-error>Phone number must be a valid US phone number</mat-error>
          } @else {
            <mat-error>Phone number is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  @if (!showReviewStatus) {
    <div class="provider-section-field">
      <div class="user-record-field-wrapper">
        <label for="secondaryPhone" class="field-label">Secondary Phone Number</label>
        <mat-form-field class="provider-fields">
          <input
            id="secondaryPhone"
            matInput
            type="text"
            [mask]="'(000) 000-0000'"
            formControlName="secondaryPhone"
            class="user-record-field-input"
            [dropSpecialCharacters]="false" />
          @if (formGroup.get('secondaryPhone')?.invalid && formGroup.get('secondaryPhone')?.touched) {
            @if (formGroup.get('secondaryPhone')?.hasError('invalidPhone')) {
              <mat-error>Phone number must be a valid US phone number</mat-error>
            } @else {
              <mat-error>Phone number is invalid</mat-error>
            }
          }
        </mat-form-field>
      </div>
    </div>
  }
  @if (providerType === 'Therapy') {
    <div class="provider-section-field">
      <div class="user-record-field-wrapper">
        <label for="birthDate" class="field-label">Date of Birth</label>
        <mat-form-field class="provider-fields">
          <input
            id="birthDate"
            [disabled]="true"
            matInput
            type="text"
            placeholder="MM/DD/YYYY"
            class="user-record-field-input"
            formControlName="birthDate"
            [mask]="'00/00/0000'" />
          @if (formGroup.get('birthDate')?.invalid && formGroup.get('birthDate')?.touched) {
            <mat-error>Date of birth is invalid</mat-error>
          } @else if (formGroup.get('birthDate')?.hasError('futureDate')) {
            <mat-error>Date of birth must be in the past</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }
</div>
